// 这里没有使用数据 -> html 的方式来渲染，是因为：
// 1，中英转化时样式有很多细节调整
// 2，即便时同语言环境下，也不是通用型的设计，存在大量需要特别调整的地方
import './solution.less'

interface PropsTypes {
  lang: Lang
}

function Solution (props: PropsTypes): JSX.Element {
  const { lang } = props

  return (
    <div className={`solution ${lang}`}>
      <h2 className='solution_title'>{__('What You Need & Our Solutions')}</h2>
      <p className='solution_desc'>{__('Create your own online store and focus on what you do the best!')}</p>
      {/* 第一个 */}
      <div className=''>
        <div className='solutionBox solutionBox_border'>
          <div className='solutionBox_top'>
            <div className='solutionBox_top_descBox'>
              <div className='solutionBox_top_descBox_titleBox'>
                <span className='redTag' />
                <h4 className='solutionBox_top_descBox_title'>{__('E-business Newbies')}</h4>
              </div>
              <p className='solutionBox_top_descBox_desc'>{__('Start e-business right away by selling Chinese products online with no experience in website building and store operation! No pressure on big upfront investment and inventory!')}</p>
            </div>
            <img className='solutionBox_top_descBox_img solutionBox_top_descBox_right' src={require('../../img/solution/solution_1.png')} alt='BuckyDrop drop-shipping image' />
          </div>
          <div className='solutionBox_bottom'>
            <div className='solutionBox_bottom_descBox'>
              <h5 className='solutionBox_bottom_descBox_title'>{__('Solutions')}</h5>
              <a className='solutionBox_bottom_descBox_link' href={`/${lang}/starter_plan`}>{__('Learn more >')}</a>
            </div>
            <div className='solutionBox_bottom_list solutionBox_bottom_list_one'>
              <div className='solutionBox_bottom_listBox'>
                <img className='solutionBox_bottom_listBox_img' src={require('../../img/solution/store_creation.svg')} alt='BuckyDrop drop-shipping image' />
                <p className='solutionBox_bottom_listBox_desc'>{__('Store Creation')}</p>
              </div>
              <div className='solutionBox_bottom_listBox'>
                <img className='solutionBox_bottom_listBox_img' src={require('../../img/solution/product_management.svg')} alt='BuckyDrop drop-shipping image' />
                <p className='solutionBox_bottom_listBox_desc'>{__('Product Management')}</p>
              </div>
              <div className='solutionBox_bottom_listBox'>
                <img className='solutionBox_bottom_listBox_img' src={require('../../img/solution/multi_channel.svg')} alt='BuckyDrop drop-shipping image' />
                <p className='solutionBox_bottom_listBox_desc'>{__('Multi-channel Marketing')}</p>
              </div>
              <div className='solutionBox_bottom_listBox'>
                <img className='solutionBox_bottom_listBox_img' src={require('../../img/solution/order_from_consumer.svg')} alt='BuckyDrop drop-shipping image' />
                <p className='solutionBox_bottom_listBox_desc'>{__('Order From Consumer')}</p>
              </div>
              <div className='solutionBox_bottom_listBox'>
                <img className='solutionBox_bottom_listBox_img' src={require('../../img/solution/order_fulfillment.svg')} alt='BuckyDrop drop-shipping image' />
                <p className='solutionBox_bottom_listBox_desc'>{__('Order Fulfillment via BuckyDrop')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* 第二个 */}
      <div className=''>
        <div className='solutionBox solutionBox_border'>
          <div className='solutionBox_top'>
            <img className='solutionBox_top_descBox_img solutionBox_top_descBox_left' src={require('../../img/solution/solution_2.png')} alt='BuckyDrop drop-shipping image' />
            <div className='solutionBox_top_descBox'>
              <div className='solutionBox_top_descBox_titleBox'>
                <span className='redTag' />
                <h4 className='solutionBox_top_descBox_title'>{__('Shopify/WooCommerce Store Owners')}</h4>
              </div>
              <p className='solutionBox_top_descBox_desc'>{__('Focus more on order fulfillment and integration of services and products with e-business expertise, so as to minimize operating costs, upgrade brands and grow business.')}</p>
            </div>
          </div>
          <div className='solutionBox_bottom'>
            <div className='solutionBox_bottom_descBox'>
              <h5 className='solutionBox_bottom_descBox_title'>{__('Solutions')}</h5>
              <a className='solutionBox_bottom_descBox_link' href={`/${lang}/plugin_service`}>{__('Learn more >')}</a>
            </div>
            <div className='solutionBox_bottom_list'>
              <div className='solutionBox_bottom_listBox'>
                <img className='solutionBox_bottom_listBox_img' src={require('../../img/solution/store_connection.svg')} alt='BuckyDrop drop-shipping image' />
                <p className='solutionBox_bottom_listBox_desc'>{__('Store Connection')}</p>
              </div>
              <div className='solutionBox_bottom_listBox'>
                <img className='solutionBox_bottom_listBox_img' src={require('../../img/solution/product_management.svg')} alt='BuckyDrop drop-shipping image' />
                <p className='solutionBox_bottom_listBox_desc'>{__('Product Management')}</p>
              </div>
              <div className='solutionBox_bottom_listBox'>
                <img className='solutionBox_bottom_listBox_img' src={require('../../img/solution/order_from_consumer.svg')} alt='BuckyDrop drop-shipping image' />
                <p className='solutionBox_bottom_listBox_desc'>{__('Order From Consumer')}</p>
              </div>
              <div className='solutionBox_bottom_listBox'>
                <img className='solutionBox_bottom_listBox_img' src={require('../../img/solution/order_fulfillment.svg')} alt='BuckyDrop drop-shipping image' />
                <p className='solutionBox_bottom_listBox_desc'>{__('Order Fulfillment via BuckyDrop')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* 第三个 */}
      <div className=''>
        <div className='solutionBox solutionBox_border'>
          <div className='solutionBox_top'>
            <div className='solutionBox_top_descBox'>
              <div className='solutionBox_top_descBox_titleBox'>
                <span className='redTag' />
                <h4 className='solutionBox_top_descBox_title solutionBox_top_descBox_title_single'>{__('Cross-border e-sellers with IT Development know-how')}</h4>
              </div>
              <p className='solutionBox_top_descBox_desc'>{__('E-marketplaces that develop their in-house systems can proceed with order fulfillment and integration of services and products via BuckyDrop OpenAPI, so as to minimize operating costs, upgrade brands and establish new business. Developers engaged in the business of developing plugin-based API services can also use BuckyDrop OpenAPI to make their business a bigger success.')}</p>
            </div>
            <img className='solutionBox_top_descBox_img solutionBox_top_descBox_right' src={require('../../img/solution/solution_3.png')} alt='BuckyDrop drop-shipping image' />
          </div>
          <div className='solutionBox_bottom'>
            <div className='solutionBox_bottom_descBox'>
              <h5 className='solutionBox_bottom_descBox_title'>{__('Solutions')}</h5>
              <a className='solutionBox_bottom_descBox_link' href={`/${lang}/open_api`}>{__('Learn more >')}</a>
            </div>
            <div className='solutionBox_bottom_list'>
              <div className='solutionBox_bottom_listBox'>
                <img className='solutionBox_bottom_listBox_img' src={require('../../img/solution/api_integration.svg')} alt='BuckyDrop drop-shipping image' />
                <p className='solutionBox_bottom_listBox_desc'>{__('Store & API Integration')}</p>
              </div>
              <div className='solutionBox_bottom_listBox'>
                <img className='solutionBox_bottom_listBox_img' src={require('../../img/solution/product_management.svg')} alt='BuckyDrop drop-shipping image' />
                <p className='solutionBox_bottom_listBox_desc'>{__('Product Management')}</p>
              </div>
              <div className='solutionBox_bottom_listBox'>
                <img className='solutionBox_bottom_listBox_img' src={require('../../img/solution/order_from_consumer.svg')} alt='BuckyDrop drop-shipping image' />
                <p className='solutionBox_bottom_listBox_desc'>{__('Order From Consumer')}</p>
              </div>
              <div className='solutionBox_bottom_listBox'>
                <img className='solutionBox_bottom_listBox_img' src={require('../../img/solution/order_fulfillment.svg')} alt='BuckyDrop drop-shipping image' />
                <p className='solutionBox_bottom_listBox_desc'>{__('Order Fulfillment via BuckyDrop')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* 第四个 */}
      <div className=''>
        <div className='solutionBox'>
          <div className='solutionBox_top'>
            <img className='solutionBox_top_descBox_img solutionBox_top_descBox_left' src={require('../../img/solution/solution_4.png')} alt='BuckyDrop drop-shipping image' />
            <div className='solutionBox_top_descBox'>
              <div className='solutionBox_top_descBox_titleBox'>
                <span className='redTag' />
                <h4 className='solutionBox_top_descBox_title'>{__('Cross-border e-sellers in no need of store connection')}</h4>
              </div>
              <p className='solutionBox_top_descBox_desc'>{__('Facilitate processes of purchasing, warehousing and shipment via BuckyDrop, with no need to connect online store (e.g. Amazon store).')}</p>
            </div>
          </div>
          <div className='solutionBox_bottom'>
            <div className='solutionBox_bottom_descBox'>
              <h5 className='solutionBox_bottom_descBox_title'>{__('Solutions')}</h5>
              <a className='solutionBox_bottom_descBox_link' href='/en/help?level=1&id=4&content=189'>{__('Learn more >')}</a>
            </div>
            <div className='solutionBox_bottom_list'>
              <div className='solutionBox_bottom_listBox solutionBox_bottom_listBox_big'>
                <img className='solutionBox_bottom_listBox_img' src={require('../../img/solution/manually_create.svg')} alt='BuckyDrop drop-shipping image' />
                <p className='solutionBox_bottom_listBox_desc'>{__('Manually create orders in BuckyDrop')}</p>
              </div>
              <div className='solutionBox_bottom_listBox'>
                <img className='solutionBox_bottom_listBox_img' src={require('../../img/solution/order_fulfillment.svg')} alt='BuckyDrop drop-shipping image' />
                <p className='solutionBox_bottom_listBox_desc'>{__('Order Fulfillment via BuckyDrop')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Solution
